// eslint-disable-next-line import/no-cycle
import type { AxiosInstance } from "axios";

import errorSent from "~/utils/errors/errorSent";
import { withHttpSpan } from "~/utils/errors/withHttpSpan";
import { logError, logTime } from "~/utils";

export const apiCallWrapper = async (
  axios: AxiosInstance,
  url = "",
  params: Record<string, unknown> = {},
  type: "get" | "post" = "get",
) => {
  const start = Date.now();

  try {
    const response = await withHttpSpan(type, url, async () => {
      if (type === "get") {
        return axios.get(url, { params });
      }
      return axios.post(url, params);
    });

    logTime(start, `[apiCallWrapper] ${type.toUpperCase()} ${url}`);
    return response.data;
  } catch (e: unknown) {
    logTime(start, `[apiCallWrapper] ERROR ${type.toUpperCase()} ${url}`);
    logError("apiCallWrapper error", {
      url,
      type,
      params,
      error: e,
    });
    errorSent(
      "apiWrapperCallError",
      "wrongResponseCode",
      {
        url,
        type,
        // Без статуса все неудачные ответы одного URL склеивались в одну issue
        // (см. getApiFingerprint): 403 от защиты периметра лежал вперемешку с
        // 503 от перегруженного бэкенда под заголовком одного из них.
        status: (e as any)?.response?.status,
        params: JSON.stringify(params),
      },
      e instanceof Error ? e : null,
    );
  }
  return null;
};
